import classNames from 'classnames';

import { PictureElement } from '@/pictureElement/Picture';

interface Props {
  avatarUrl?: string;
  className?: string;
}

const DEFAULT_AVATAR_URL =
  'https://media.beehiiv.com/cdn-cgi/image/format=auto/static_assets/subscription_dummy_avatar_0.svg';

const SubscriptionAvatar = ({ avatarUrl, className }: Props) => {
  const imgSrc = avatarUrl || DEFAULT_AVATAR_URL;
  return (
    <PictureElement src={imgSrc}>
      <img
        src={imgSrc}
        alt="Avatar"
        className={classNames('w-full h-full rounded-full object-cover bg-center', className)}
      />
    </PictureElement>
  );
};

export default SubscriptionAvatar;
